import Vue from 'vue';

Vue.filter('paginate', (list = [], page_num, per_page) => {
	let index = (page_num - 1) * per_page;
	return list.slice(index, index + per_page);
});



// WEBPACK FOOTER //
// ./src/filters/pagination.js